import { get, post } from '../../utils/http';

export const submitQuestionProjectAiChat = ({ accountId, branchId, projectId, threadId, question }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/ai-chat/${threadId}/question`, {
    question: question
  });

export const fetchQuestionResponseProjectAiChat = ({ accountId, branchId, projectId, threadId, questionId }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/ai-chat/${threadId}/question/${questionId}`);
